"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AddPainGuideCategoryTranslationParams = _interopRequireDefault(require("../model/AddPainGuideCategoryTranslationParams"));
var _AddPainGuideContentTranslationParams = _interopRequireDefault(require("../model/AddPainGuideContentTranslationParams"));
var _AddUserToInstitutionParams = _interopRequireDefault(require("../model/AddUserToInstitutionParams"));
var _ApiCreatePainGuideContentCategoryObject = _interopRequireDefault(require("../model/ApiCreatePainGuideContentCategoryObject"));
var _ApiCreatePainGuideContentObject = _interopRequireDefault(require("../model/ApiCreatePainGuideContentObject"));
var _ApiCreateUserObject = _interopRequireDefault(require("../model/ApiCreateUserObject"));
var _ApiGetSectionFieldObject = _interopRequireDefault(require("../model/ApiGetSectionFieldObject"));
var _ApiUserInfoObject = _interopRequireDefault(require("../model/ApiUserInfoObject"));
var _ApitestActivateUserPostRequest = _interopRequireDefault(require("../model/ApitestActivateUserPostRequest"));
var _ApitestAddQuestionnairePost200Response = _interopRequireDefault(require("../model/ApitestAddQuestionnairePost200Response"));
var _ApitestCreateInstitutionPost200Response = _interopRequireDefault(require("../model/ApitestCreateInstitutionPost200Response"));
var _ApitestCreatePainGuideContentPriorityTemplatePostRequest = _interopRequireDefault(require("../model/ApitestCreatePainGuideContentPriorityTemplatePostRequest"));
var _ApitestCreateQuestionnaireGroupPost200Response = _interopRequireDefault(require("../model/ApitestCreateQuestionnaireGroupPost200Response"));
var _ApitestCreateQuestionnairePost200Response = _interopRequireDefault(require("../model/ApitestCreateQuestionnairePost200Response"));
var _ApitestCreateRandomUserPostRequest = _interopRequireDefault(require("../model/ApitestCreateRandomUserPostRequest"));
var _ApitestDeleteMedicationNamePostRequest = _interopRequireDefault(require("../model/ApitestDeleteMedicationNamePostRequest"));
var _ApitestDeleteMedicationPostRequest = _interopRequireDefault(require("../model/ApitestDeleteMedicationPostRequest"));
var _ApitestDeletePainGuideContentPriorityTemplatePostRequest = _interopRequireDefault(require("../model/ApitestDeletePainGuideContentPriorityTemplatePostRequest"));
var _ApitestDeleteQuestionnairePost200Response = _interopRequireDefault(require("../model/ApitestDeleteQuestionnairePost200Response"));
var _ApitestDeleteUserPostRequest = _interopRequireDefault(require("../model/ApitestDeleteUserPostRequest"));
var _ApitestEditActivationCodePost200Response = _interopRequireDefault(require("../model/ApitestEditActivationCodePost200Response"));
var _ApitestEditPurchaseFlagsPost200Response = _interopRequireDefault(require("../model/ApitestEditPurchaseFlagsPost200Response"));
var _ApitestGenerateUnsubscribeEmailTokenPost200Response = _interopRequireDefault(require("../model/ApitestGenerateUnsubscribeEmailTokenPost200Response"));
var _ApitestGenerateUnsubscribeEmailTokenPostRequest = _interopRequireDefault(require("../model/ApitestGenerateUnsubscribeEmailTokenPostRequest"));
var _ApitestGetAccountTokenPost200Response = _interopRequireDefault(require("../model/ApitestGetAccountTokenPost200Response"));
var _ApitestGetActivationCodePost200Response = _interopRequireDefault(require("../model/ApitestGetActivationCodePost200Response"));
var _ApitestGetConfigVariablePost200Response = _interopRequireDefault(require("../model/ApitestGetConfigVariablePost200Response"));
var _ApitestGetConfigVariablePostRequest = _interopRequireDefault(require("../model/ApitestGetConfigVariablePostRequest"));
var _ApitestGetEmailTokenPost200Response = _interopRequireDefault(require("../model/ApitestGetEmailTokenPost200Response"));
var _ApitestGetEmailTokenPostRequest = _interopRequireDefault(require("../model/ApitestGetEmailTokenPostRequest"));
var _ApitestGetLastReportIdsPost200Response = _interopRequireDefault(require("../model/ApitestGetLastReportIdsPost200Response"));
var _ApitestGetNotificationLogsPost200Response = _interopRequireDefault(require("../model/ApitestGetNotificationLogsPost200Response"));
var _ApitestGetResetPasswordTokenPost200Response = _interopRequireDefault(require("../model/ApitestGetResetPasswordTokenPost200Response"));
var _ApitestGetSampleUsersPost200Response = _interopRequireDefault(require("../model/ApitestGetSampleUsersPost200Response"));
var _ApitestGetServerTimePost200Response = _interopRequireDefault(require("../model/ApitestGetServerTimePost200Response"));
var _ApitestSetConfigVariablePostRequest = _interopRequireDefault(require("../model/ApitestSetConfigVariablePostRequest"));
var _AssignQuestionnaireParams = _interopRequireDefault(require("../model/AssignQuestionnaireParams"));
var _ChangeCacheStatusParams = _interopRequireDefault(require("../model/ChangeCacheStatusParams"));
var _ChangeOfflineStatusParams = _interopRequireDefault(require("../model/ChangeOfflineStatusParams"));
var _CreateInstitutionParams = _interopRequireDefault(require("../model/CreateInstitutionParams"));
var _CreatePainGuideContentCategoryParams = _interopRequireDefault(require("../model/CreatePainGuideContentCategoryParams"));
var _CreatePainGuideContentParams = _interopRequireDefault(require("../model/CreatePainGuideContentParams"));
var _CreateSampleUser = _interopRequireDefault(require("../model/CreateSampleUser"));
var _CreateSectionFieldTranslationParams = _interopRequireDefault(require("../model/CreateSectionFieldTranslationParams"));
var _CreateUserParams = _interopRequireDefault(require("../model/CreateUserParams"));
var _DeleteInstitutionParams = _interopRequireDefault(require("../model/DeleteInstitutionParams"));
var _DeletePainGuideContentCategoryParams = _interopRequireDefault(require("../model/DeletePainGuideContentCategoryParams"));
var _DeletePainGuideContentParams = _interopRequireDefault(require("../model/DeletePainGuideContentParams"));
var _DeleteQuestionnaireParams = _interopRequireDefault(require("../model/DeleteQuestionnaireParams"));
var _DeleteTestSectionFieldParams = _interopRequireDefault(require("../model/DeleteTestSectionFieldParams"));
var _EditActivationCodeParams = _interopRequireDefault(require("../model/EditActivationCodeParams"));
var _EditPurchaseFlags = _interopRequireDefault(require("../model/EditPurchaseFlags"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _GetAccountTokenParams = _interopRequireDefault(require("../model/GetAccountTokenParams"));
var _GetActivationCodeParams = _interopRequireDefault(require("../model/GetActivationCodeParams"));
var _GetNotificationLogs = _interopRequireDefault(require("../model/GetNotificationLogs"));
var _GetSampleUsers = _interopRequireDefault(require("../model/GetSampleUsers"));
var _GetSectionFieldParams = _interopRequireDefault(require("../model/GetSectionFieldParams"));
var _GetServerTimeParams = _interopRequireDefault(require("../model/GetServerTimeParams"));
var _InvalidToken = _interopRequireDefault(require("../model/InvalidToken"));
var _Language = _interopRequireDefault(require("../model/Language"));
var _PrepareInstitutionFilesParams = _interopRequireDefault(require("../model/PrepareInstitutionFilesParams"));
var _ProgramsUpdateProgramProgressPost200Response = _interopRequireDefault(require("../model/ProgramsUpdateProgramProgressPost200Response"));
var _TestQuestionnaireGroupObjectParams = _interopRequireDefault(require("../model/TestQuestionnaireGroupObjectParams"));
var _TestQuestionnaireObjectParams = _interopRequireDefault(require("../model/TestQuestionnaireObjectParams"));
var _WaitReportCompletionParams = _interopRequireDefault(require("../model/WaitReportCompletionParams"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* TestDevPreprodOnly service.
* @module api/TestDevPreprodOnlyApi
* @version 4.0.0
*/
var TestDevPreprodOnlyApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new TestDevPreprodOnlyApi. 
  * @alias module:api/TestDevPreprodOnlyApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TestDevPreprodOnlyApi(apiClient) {
    _classCallCheck(this, TestDevPreprodOnlyApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * activate-user
   * Test call that activates specified user, bypassing the need to click on the activation link sent via email
   * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
   * @param {module:model/ApitestActivateUserPostRequest} params 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */
  return _createClass(TestDevPreprodOnlyApi, [{
    key: "apitestActivateUserPostWithHttpInfo",
    value: function apitestActivateUserPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestActivateUserPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestActivateUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/apitest/activate-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * activate-user
     * Test call that activates specified user, bypassing the need to click on the activation link sent via email
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestActivateUserPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "apitestActivateUserPost",
    value: function apitestActivateUserPost(Accept_Language, params) {
      return this.apitestActivateUserPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * add-pain-guide-category-translation
     * Add translation for specified Pain Guide category and language
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddPainGuideCategoryTranslationParams} AddPainGuideCategoryTranslationParams 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestAddPainGuideCategoryTranslationPostWithHttpInfo",
    value: function apitestAddPainGuideCategoryTranslationPostWithHttpInfo(Accept_Language, AddPainGuideCategoryTranslationParams) {
      var postBody = AddPainGuideCategoryTranslationParams;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestAddPainGuideCategoryTranslationPost");
      }
      // verify the required parameter 'AddPainGuideCategoryTranslationParams' is set
      if (AddPainGuideCategoryTranslationParams === undefined || AddPainGuideCategoryTranslationParams === null) {
        throw new Error("Missing the required parameter 'AddPainGuideCategoryTranslationParams' when calling apitestAddPainGuideCategoryTranslationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/add-pain-guide-category-translation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-pain-guide-category-translation
     * Add translation for specified Pain Guide category and language
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddPainGuideCategoryTranslationParams} AddPainGuideCategoryTranslationParams 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestAddPainGuideCategoryTranslationPost",
    value: function apitestAddPainGuideCategoryTranslationPost(Accept_Language, AddPainGuideCategoryTranslationParams) {
      return this.apitestAddPainGuideCategoryTranslationPostWithHttpInfo(Accept_Language, AddPainGuideCategoryTranslationParams).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * add-pain-guide-content-translation
     * Add translation for specified Pain Guide content and language
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddPainGuideContentTranslationParams} AddPainGuideContentTranslationParams 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestAddPainGuideContentTranslationPostWithHttpInfo",
    value: function apitestAddPainGuideContentTranslationPostWithHttpInfo(Accept_Language, AddPainGuideContentTranslationParams) {
      var postBody = AddPainGuideContentTranslationParams;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestAddPainGuideContentTranslationPost");
      }
      // verify the required parameter 'AddPainGuideContentTranslationParams' is set
      if (AddPainGuideContentTranslationParams === undefined || AddPainGuideContentTranslationParams === null) {
        throw new Error("Missing the required parameter 'AddPainGuideContentTranslationParams' when calling apitestAddPainGuideContentTranslationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/add-pain-guide-content-translation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-pain-guide-content-translation
     * Add translation for specified Pain Guide content and language
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddPainGuideContentTranslationParams} AddPainGuideContentTranslationParams 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestAddPainGuideContentTranslationPost",
    value: function apitestAddPainGuideContentTranslationPost(Accept_Language, AddPainGuideContentTranslationParams) {
      return this.apitestAddPainGuideContentTranslationPostWithHttpInfo(Accept_Language, AddPainGuideContentTranslationParams).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * add-questionnaire
     * Add questionnaire to institution
     * @param {Object} opts Optional parameters
     * @param {module:model/AssignQuestionnaireParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestAddQuestionnairePost200Response} and HTTP response
     */
  }, {
    key: "apitestAddQuestionnairePostWithHttpInfo",
    value: function apitestAddQuestionnairePostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestAddQuestionnairePost200Response["default"];
      return this.apiClient.callApi('/apitest/add-questionnaire', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-questionnaire
     * Add questionnaire to institution
     * @param {Object} opts Optional parameters
     * @param {module:model/AssignQuestionnaireParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestAddQuestionnairePost200Response}
     */
  }, {
    key: "apitestAddQuestionnairePost",
    value: function apitestAddQuestionnairePost(opts) {
      return this.apitestAddQuestionnairePostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * add-user-to-institution
     * Test call that assigns user to the institution. Validation checks that `clientMax` isn't exceeded, `study_id` is provided and valid (if applicable)
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddUserToInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestAddUserToInstitutionPostWithHttpInfo",
    value: function apitestAddUserToInstitutionPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestAddUserToInstitutionPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestAddUserToInstitutionPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/add-user-to-institution', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * add-user-to-institution
     * Test call that assigns user to the institution. Validation checks that `clientMax` isn't exceeded, `study_id` is provided and valid (if applicable)
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AddUserToInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestAddUserToInstitutionPost",
    value: function apitestAddUserToInstitutionPost(Accept_Language, params) {
      return this.apitestAddUserToInstitutionPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * change-cache-service-status
     * Test call that changes cache service status(sets lcs_alerts_use_cache variable to 0 or 1).
     * @param {module:model/ChangeCacheStatusParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestChangeCacheServiceStatusPostWithHttpInfo",
    value: function apitestChangeCacheServiceStatusPostWithHttpInfo(params) {
      var postBody = params;
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestChangeCacheServiceStatusPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/change-cache-service-status', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * change-cache-service-status
     * Test call that changes cache service status(sets lcs_alerts_use_cache variable to 0 or 1).
     * @param {module:model/ChangeCacheStatusParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestChangeCacheServiceStatusPost",
    value: function apitestChangeCacheServiceStatusPost(params) {
      return this.apitestChangeCacheServiceStatusPostWithHttpInfo(params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * change-offline-mode
     * Test call that changes maintenance status(sets site_offline variable to 0 or 1).
     * @param {module:model/ChangeOfflineStatusParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestChangeOfflineModePostWithHttpInfo",
    value: function apitestChangeOfflineModePostWithHttpInfo(params) {
      var postBody = params;
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestChangeOfflineModePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/change-offline-mode', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * change-offline-mode
     * Test call that changes maintenance status(sets site_offline variable to 0 or 1).
     * @param {module:model/ChangeOfflineStatusParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestChangeOfflineModePost",
    value: function apitestChangeOfflineModePost(params) {
      return this.apitestChangeOfflineModePostWithHttpInfo(params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-institution
     * Test call that creates institution
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreateInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestCreateInstitutionPost200Response} and HTTP response
     */
  }, {
    key: "apitestCreateInstitutionPostWithHttpInfo",
    value: function apitestCreateInstitutionPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestCreateInstitutionPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestCreateInstitutionPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestCreateInstitutionPost200Response["default"];
      return this.apiClient.callApi('/apitest/create-institution', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-institution
     * Test call that creates institution
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreateInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestCreateInstitutionPost200Response}
     */
  }, {
    key: "apitestCreateInstitutionPost",
    value: function apitestCreateInstitutionPost(Accept_Language, params) {
      return this.apitestCreateInstitutionPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-pain-guide-content-category
     * Create a single content category for Pain Guide. If content category with the same name exists, returns response for existing one
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreatePainGuideContentCategoryParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiCreatePainGuideContentCategoryObject} and HTTP response
     */
  }, {
    key: "apitestCreatePainGuideContentCategoryPostWithHttpInfo",
    value: function apitestCreatePainGuideContentCategoryPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestCreatePainGuideContentCategoryPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestCreatePainGuideContentCategoryPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiCreatePainGuideContentCategoryObject["default"];
      return this.apiClient.callApi('/apitest/create-pain-guide-content-category', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-pain-guide-content-category
     * Create a single content category for Pain Guide. If content category with the same name exists, returns response for existing one
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreatePainGuideContentCategoryParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiCreatePainGuideContentCategoryObject}
     */
  }, {
    key: "apitestCreatePainGuideContentCategoryPost",
    value: function apitestCreatePainGuideContentCategoryPost(Accept_Language, params) {
      return this.apitestCreatePainGuideContentCategoryPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-pain-guide-content
     * Create a single HTML page content unit with content wrapper for Pain Guide. If content unit with the same title exists, returns response for existing one
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreatePainGuideContentParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiCreatePainGuideContentObject} and HTTP response
     */
  }, {
    key: "apitestCreatePainGuideContentPostWithHttpInfo",
    value: function apitestCreatePainGuideContentPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestCreatePainGuideContentPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestCreatePainGuideContentPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiCreatePainGuideContentObject["default"];
      return this.apiClient.callApi('/apitest/create-pain-guide-content', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-pain-guide-content
     * Create a single HTML page content unit with content wrapper for Pain Guide. If content unit with the same title exists, returns response for existing one
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreatePainGuideContentParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiCreatePainGuideContentObject}
     */
  }, {
    key: "apitestCreatePainGuideContentPost",
    value: function apitestCreatePainGuideContentPost(Accept_Language, params) {
      return this.apitestCreatePainGuideContentPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-pain-guide-content-priority-template
     * Create pain guide priority template
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestCreatePainGuideContentPriorityTemplatePostRequest} ApitestCreatePainGuideContentPriorityTemplatePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestCreatePainGuideContentPriorityTemplatePostWithHttpInfo",
    value: function apitestCreatePainGuideContentPriorityTemplatePostWithHttpInfo(Accept_Language, ApitestCreatePainGuideContentPriorityTemplatePostRequest) {
      var postBody = ApitestCreatePainGuideContentPriorityTemplatePostRequest;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestCreatePainGuideContentPriorityTemplatePost");
      }
      // verify the required parameter 'ApitestCreatePainGuideContentPriorityTemplatePostRequest' is set
      if (ApitestCreatePainGuideContentPriorityTemplatePostRequest === undefined || ApitestCreatePainGuideContentPriorityTemplatePostRequest === null) {
        throw new Error("Missing the required parameter 'ApitestCreatePainGuideContentPriorityTemplatePostRequest' when calling apitestCreatePainGuideContentPriorityTemplatePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/create-pain-guide-content-priority-template', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-pain-guide-content-priority-template
     * Create pain guide priority template
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestCreatePainGuideContentPriorityTemplatePostRequest} ApitestCreatePainGuideContentPriorityTemplatePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestCreatePainGuideContentPriorityTemplatePost",
    value: function apitestCreatePainGuideContentPriorityTemplatePost(Accept_Language, ApitestCreatePainGuideContentPriorityTemplatePostRequest) {
      return this.apitestCreatePainGuideContentPriorityTemplatePostWithHttpInfo(Accept_Language, ApitestCreatePainGuideContentPriorityTemplatePostRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-questionnaire-group
     * Create new questionnaire group
     * @param {Object} opts Optional parameters
     * @param {module:model/TestQuestionnaireGroupObjectParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestCreateQuestionnaireGroupPost200Response} and HTTP response
     */
  }, {
    key: "apitestCreateQuestionnaireGroupPostWithHttpInfo",
    value: function apitestCreateQuestionnaireGroupPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestCreateQuestionnaireGroupPost200Response["default"];
      return this.apiClient.callApi('/apitest/create-questionnaire-group', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-questionnaire-group
     * Create new questionnaire group
     * @param {Object} opts Optional parameters
     * @param {module:model/TestQuestionnaireGroupObjectParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestCreateQuestionnaireGroupPost200Response}
     */
  }, {
    key: "apitestCreateQuestionnaireGroupPost",
    value: function apitestCreateQuestionnaireGroupPost(opts) {
      return this.apitestCreateQuestionnaireGroupPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-questionnaire
     * Create new questionnaire
     * @param {Object} opts Optional parameters
     * @param {module:model/TestQuestionnaireObjectParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestCreateQuestionnairePost200Response} and HTTP response
     */
  }, {
    key: "apitestCreateQuestionnairePostWithHttpInfo",
    value: function apitestCreateQuestionnairePostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestCreateQuestionnairePost200Response["default"];
      return this.apiClient.callApi('/apitest/create-questionnaire', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-questionnaire
     * Create new questionnaire
     * @param {Object} opts Optional parameters
     * @param {module:model/TestQuestionnaireObjectParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestCreateQuestionnairePost200Response}
     */
  }, {
    key: "apitestCreateQuestionnairePost",
    value: function apitestCreateQuestionnairePost(opts) {
      return this.apitestCreateQuestionnairePostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-random-user
     * Test call that creates a user with random username and email.
     * @param {module:model/ApitestCreateRandomUserPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiCreateUserObject} and HTTP response
     */
  }, {
    key: "apitestCreateRandomUserPostWithHttpInfo",
    value: function apitestCreateRandomUserPostWithHttpInfo(params) {
      var postBody = params;
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestCreateRandomUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiCreateUserObject["default"];
      return this.apiClient.callApi('/apitest/create-random-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-random-user
     * Test call that creates a user with random username and email.
     * @param {module:model/ApitestCreateRandomUserPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiCreateUserObject}
     */
  }, {
    key: "apitestCreateRandomUserPost",
    value: function apitestCreateRandomUserPost(params) {
      return this.apitestCreateRandomUserPostWithHttpInfo(params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-sample-user
     * Create sample user with pain records and daily reflection. For creation we use batch process. After response need to wait while batch process creates users. Sample user starts cron-job every day to create new records.
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSampleUser} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestCreateSampleUserPostWithHttpInfo",
    value: function apitestCreateSampleUserPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/create-sample-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-sample-user
     * Create sample user with pain records and daily reflection. For creation we use batch process. After response need to wait while batch process creates users. Sample user starts cron-job every day to create new records.
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateSampleUser} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestCreateSampleUserPost",
    value: function apitestCreateSampleUserPost(opts) {
      return this.apitestCreateSampleUserPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-section-field-translation
     * Test call that creates translations for section-fields (pain conditions)
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreateSectionFieldTranslationParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestCreateSectionFieldTranslationPostWithHttpInfo",
    value: function apitestCreateSectionFieldTranslationPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestCreateSectionFieldTranslationPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestCreateSectionFieldTranslationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/create-section-field-translation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-section-field-translation
     * Test call that creates translations for section-fields (pain conditions)
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreateSectionFieldTranslationParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestCreateSectionFieldTranslationPost",
    value: function apitestCreateSectionFieldTranslationPost(Accept_Language, params) {
      return this.apitestCreateSectionFieldTranslationPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * create-user
     * Test call that creates a new user using specified parameters
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreateUserParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiCreateUserObject} and HTTP response
     */
  }, {
    key: "apitestCreateUserPostWithHttpInfo",
    value: function apitestCreateUserPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestCreateUserPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestCreateUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiCreateUserObject["default"];
      return this.apiClient.callApi('/apitest/create-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * create-user
     * Test call that creates a new user using specified parameters
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CreateUserParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiCreateUserObject}
     */
  }, {
    key: "apitestCreateUserPost",
    value: function apitestCreateUserPost(Accept_Language, params) {
      return this.apitestCreateUserPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-institution
     * Test call that deletes institution. Provided `token` should match the user who created the institution.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestDeleteInstitutionPostWithHttpInfo",
    value: function apitestDeleteInstitutionPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeleteInstitutionPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeleteInstitutionPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/delete-institution', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-institution
     * Test call that deletes institution. Provided `token` should match the user who created the institution.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteInstitutionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestDeleteInstitutionPost",
    value: function apitestDeleteInstitutionPost(Accept_Language, params) {
      return this.apitestDeleteInstitutionPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-medication-name
     * Delete a medication name and all related entities (Medication brands, LCS fields, user medications, medication statistics) by common name. Updates all related pain records, user profiles and user preferences.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeleteMedicationNamePostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestDeleteMedicationNamePostWithHttpInfo",
    value: function apitestDeleteMedicationNamePostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeleteMedicationNamePost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeleteMedicationNamePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/delete-medication-name', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-medication-name
     * Delete a medication name and all related entities (Medication brands, LCS fields, user medications, medication statistics) by common name. Updates all related pain records, user profiles and user preferences.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeleteMedicationNamePostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestDeleteMedicationNamePost",
    value: function apitestDeleteMedicationNamePost(Accept_Language, params) {
      return this.apitestDeleteMedicationNamePostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-medication
     * Delete a medication and all related entities (LCS fields, user medications, medication statistics) by brand. Updates all related pain records, user profiles and user preferences.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeleteMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestDeleteMedicationPostWithHttpInfo",
    value: function apitestDeleteMedicationPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeleteMedicationPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeleteMedicationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/delete-medication', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-medication
     * Delete a medication and all related entities (LCS fields, user medications, medication statistics) by brand. Updates all related pain records, user profiles and user preferences.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeleteMedicationPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestDeleteMedicationPost",
    value: function apitestDeleteMedicationPost(Accept_Language, params) {
      return this.apitestDeleteMedicationPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-pain-guide-content-category
     * Delete a content category by name
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeletePainGuideContentCategoryParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestDeletePainGuideContentCategoryPostWithHttpInfo",
    value: function apitestDeletePainGuideContentCategoryPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeletePainGuideContentCategoryPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeletePainGuideContentCategoryPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/delete-pain-guide-content-category', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-pain-guide-content-category
     * Delete a content category by name
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeletePainGuideContentCategoryParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestDeletePainGuideContentCategoryPost",
    value: function apitestDeletePainGuideContentCategoryPost(Accept_Language, params) {
      return this.apitestDeletePainGuideContentCategoryPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-pain-guide-content
     * Delete an HTML page content unit and content wrapper by title
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeletePainGuideContentParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestDeletePainGuideContentPostWithHttpInfo",
    value: function apitestDeletePainGuideContentPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeletePainGuideContentPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeletePainGuideContentPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/delete-pain-guide-content', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-pain-guide-content
     * Delete an HTML page content unit and content wrapper by title
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeletePainGuideContentParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestDeletePainGuideContentPost",
    value: function apitestDeletePainGuideContentPost(Accept_Language, params) {
      return this.apitestDeletePainGuideContentPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-pain-guide-content-priority-template
     * Remove all pain guide priority templates with name specified
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeletePainGuideContentPriorityTemplatePostRequest} ApitestDeletePainGuideContentPriorityTemplatePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestDeletePainGuideContentPriorityTemplatePostWithHttpInfo",
    value: function apitestDeletePainGuideContentPriorityTemplatePostWithHttpInfo(Accept_Language, ApitestDeletePainGuideContentPriorityTemplatePostRequest) {
      var postBody = ApitestDeletePainGuideContentPriorityTemplatePostRequest;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeletePainGuideContentPriorityTemplatePost");
      }
      // verify the required parameter 'ApitestDeletePainGuideContentPriorityTemplatePostRequest' is set
      if (ApitestDeletePainGuideContentPriorityTemplatePostRequest === undefined || ApitestDeletePainGuideContentPriorityTemplatePostRequest === null) {
        throw new Error("Missing the required parameter 'ApitestDeletePainGuideContentPriorityTemplatePostRequest' when calling apitestDeletePainGuideContentPriorityTemplatePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/delete-pain-guide-content-priority-template', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-pain-guide-content-priority-template
     * Remove all pain guide priority templates with name specified
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeletePainGuideContentPriorityTemplatePostRequest} ApitestDeletePainGuideContentPriorityTemplatePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestDeletePainGuideContentPriorityTemplatePost",
    value: function apitestDeletePainGuideContentPriorityTemplatePost(Accept_Language, ApitestDeletePainGuideContentPriorityTemplatePostRequest) {
      return this.apitestDeletePainGuideContentPriorityTemplatePostWithHttpInfo(Accept_Language, ApitestDeletePainGuideContentPriorityTemplatePostRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-questionnaire
     * Delete questionnaire
     * @param {Object} opts Optional parameters
     * @param {module:model/DeleteQuestionnaireParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestDeleteQuestionnairePost200Response} and HTTP response
     */
  }, {
    key: "apitestDeleteQuestionnairePostWithHttpInfo",
    value: function apitestDeleteQuestionnairePostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestDeleteQuestionnairePost200Response["default"];
      return this.apiClient.callApi('/apitest/delete-questionnaire', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-questionnaire
     * Delete questionnaire
     * @param {Object} opts Optional parameters
     * @param {module:model/DeleteQuestionnaireParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestDeleteQuestionnairePost200Response}
     */
  }, {
    key: "apitestDeleteQuestionnairePost",
    value: function apitestDeleteQuestionnairePost(opts) {
      return this.apitestDeleteQuestionnairePostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-test-purchase
     * Delete a Google purchase from the list of user's Google purchases
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestDeleteTestPurchasePostWithHttpInfo",
    value: function apitestDeleteTestPurchasePostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/delete-test-purchase', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-test-purchase
     * Delete a Google purchase from the list of user's Google purchases
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestDeleteTestPurchasePost",
    value: function apitestDeleteTestPurchasePost() {
      return this.apitestDeleteTestPurchasePostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-test-section-field
     * Test API call to remove section field and translations for it by value and type. Used to remove xection fields created by create-section-field-translation test API call
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteTestSectionFieldParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestDeleteTestSectionFieldPostWithHttpInfo",
    value: function apitestDeleteTestSectionFieldPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeleteTestSectionFieldPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeleteTestSectionFieldPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/delete-test-section-field', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-test-section-field
     * Test API call to remove section field and translations for it by value and type. Used to remove xection fields created by create-section-field-translation test API call
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteTestSectionFieldParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestDeleteTestSectionFieldPost",
    value: function apitestDeleteTestSectionFieldPost(Accept_Language, params) {
      return this.apitestDeleteTestSectionFieldPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-user
     * Test call that deletes specified user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeleteUserPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "apitestDeleteUserPostWithHttpInfo",
    value: function apitestDeleteUserPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestDeleteUserPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestDeleteUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/apitest/delete-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-user
     * Test call that deletes specified user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestDeleteUserPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "apitestDeleteUserPost",
    value: function apitestDeleteUserPost(Accept_Language, params) {
      return this.apitestDeleteUserPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * disable-bruteforce-protection
     * Test call that disables bruteforce protection(sets LCS_FLOOD_TEST_MODE variable to true).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestDisableBruteforceProtectionPostWithHttpInfo",
    value: function apitestDisableBruteforceProtectionPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/disable-bruteforce-protection', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * disable-bruteforce-protection
     * Test call that disables bruteforce protection(sets LCS_FLOOD_TEST_MODE variable to true).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestDisableBruteforceProtectionPost",
    value: function apitestDisableBruteforceProtectionPost() {
      return this.apitestDisableBruteforceProtectionPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-activation-code
     * Change or delete activation code parameters generated in `invite-user` for provided email.
     * @param {Object} opts Optional parameters
     * @param {module:model/EditActivationCodeParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestEditActivationCodePost200Response} and HTTP response
     */
  }, {
    key: "apitestEditActivationCodePostWithHttpInfo",
    value: function apitestEditActivationCodePostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestEditActivationCodePost200Response["default"];
      return this.apiClient.callApi('/apitest/edit-activation-code', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-activation-code
     * Change or delete activation code parameters generated in `invite-user` for provided email.
     * @param {Object} opts Optional parameters
     * @param {module:model/EditActivationCodeParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestEditActivationCodePost200Response}
     */
  }, {
    key: "apitestEditActivationCodePost",
    value: function apitestEditActivationCodePost(opts) {
      return this.apitestEditActivationCodePostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * edit-purchase-flags
     * Edit \"is_subscriber\" and \"enable_pro\" flags for user
     * @param {Object} opts Optional parameters
     * @param {module:model/EditPurchaseFlags} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestEditPurchaseFlagsPost200Response} and HTTP response
     */
  }, {
    key: "apitestEditPurchaseFlagsPostWithHttpInfo",
    value: function apitestEditPurchaseFlagsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestEditPurchaseFlagsPost200Response["default"];
      return this.apiClient.callApi('/apitest/edit-purchase-flags', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * edit-purchase-flags
     * Edit \"is_subscriber\" and \"enable_pro\" flags for user
     * @param {Object} opts Optional parameters
     * @param {module:model/EditPurchaseFlags} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestEditPurchaseFlagsPost200Response}
     */
  }, {
    key: "apitestEditPurchaseFlagsPost",
    value: function apitestEditPurchaseFlagsPost(opts) {
      return this.apitestEditPurchaseFlagsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * enable-bruteforce-protection
     * Test call that enables bruteforce protection(sets LCS_FLOOD_TEST_MODE variable to false).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestEnableBruteforceProtectionPostWithHttpInfo",
    value: function apitestEnableBruteforceProtectionPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/enable-bruteforce-protection', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * enable-bruteforce-protection
     * Test call that enables bruteforce protection(sets LCS_FLOOD_TEST_MODE variable to false).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestEnableBruteforceProtectionPost",
    value: function apitestEnableBruteforceProtectionPost() {
      return this.apitestEnableBruteforceProtectionPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * expire-token
     * Test call that forces the expiration (not invalidation or deletion) of the specified token.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "apitestExpireTokenPostWithHttpInfo",
    value: function apitestExpireTokenPostWithHttpInfo(Accept_Language) {
      var postBody = null;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestExpireTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/apitest/expire-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * expire-token
     * Test call that forces the expiration (not invalidation or deletion) of the specified token.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "apitestExpireTokenPost",
    value: function apitestExpireTokenPost(Accept_Language) {
      return this.apitestExpireTokenPostWithHttpInfo(Accept_Language).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * generate-unsubscribe-email-token
     * Test call that returns unsubscribe-email jwt token
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestGenerateUnsubscribeEmailTokenPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGenerateUnsubscribeEmailTokenPost200Response} and HTTP response
     */
  }, {
    key: "apitestGenerateUnsubscribeEmailTokenPostWithHttpInfo",
    value: function apitestGenerateUnsubscribeEmailTokenPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestGenerateUnsubscribeEmailTokenPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestGenerateUnsubscribeEmailTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGenerateUnsubscribeEmailTokenPost200Response["default"];
      return this.apiClient.callApi('/apitest/generate-unsubscribe-email-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * generate-unsubscribe-email-token
     * Test call that returns unsubscribe-email jwt token
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestGenerateUnsubscribeEmailTokenPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGenerateUnsubscribeEmailTokenPost200Response}
     */
  }, {
    key: "apitestGenerateUnsubscribeEmailTokenPost",
    value: function apitestGenerateUnsubscribeEmailTokenPost(Accept_Language, params) {
      return this.apitestGenerateUnsubscribeEmailTokenPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-account-token
     * Test API call to get account activation token for provided user
     * @param {module:model/GetAccountTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetAccountTokenPost200Response} and HTTP response
     */
  }, {
    key: "apitestGetAccountTokenPostWithHttpInfo",
    value: function apitestGetAccountTokenPostWithHttpInfo(params) {
      var postBody = params;
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestGetAccountTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetAccountTokenPost200Response["default"];
      return this.apiClient.callApi('/apitest/get-account-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-account-token
     * Test API call to get account activation token for provided user
     * @param {module:model/GetAccountTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetAccountTokenPost200Response}
     */
  }, {
    key: "apitestGetAccountTokenPost",
    value: function apitestGetAccountTokenPost(params) {
      return this.apitestGetAccountTokenPostWithHttpInfo(params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-activation-code
     * Return activation code generated in `invite-user` for provided email. Activation code should be provided to real user only via email.
     * @param {Object} opts Optional parameters
     * @param {module:model/GetActivationCodeParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetActivationCodePost200Response} and HTTP response
     */
  }, {
    key: "apitestGetActivationCodePostWithHttpInfo",
    value: function apitestGetActivationCodePostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetActivationCodePost200Response["default"];
      return this.apiClient.callApi('/apitest/get-activation-code', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-activation-code
     * Return activation code generated in `invite-user` for provided email. Activation code should be provided to real user only via email.
     * @param {Object} opts Optional parameters
     * @param {module:model/GetActivationCodeParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetActivationCodePost200Response}
     */
  }, {
    key: "apitestGetActivationCodePost",
    value: function apitestGetActivationCodePost(opts) {
      return this.apitestGetActivationCodePostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-config-variable
     * Return configuration variable value. It will return `null` if variable not exist.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Object} opts Optional parameters
     * @param {module:model/ApitestGetConfigVariablePostRequest} [ApitestGetConfigVariablePostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetConfigVariablePost200Response} and HTTP response
     */
  }, {
    key: "apitestGetConfigVariablePostWithHttpInfo",
    value: function apitestGetConfigVariablePostWithHttpInfo(Accept_Language, opts) {
      opts = opts || {};
      var postBody = opts['ApitestGetConfigVariablePostRequest'];
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestGetConfigVariablePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['aplication/json', 'application/json'];
      var returnType = _ApitestGetConfigVariablePost200Response["default"];
      return this.apiClient.callApi('/apitest/get-config-variable', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-config-variable
     * Return configuration variable value. It will return `null` if variable not exist.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Object} opts Optional parameters
     * @param {module:model/ApitestGetConfigVariablePostRequest} opts.ApitestGetConfigVariablePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetConfigVariablePost200Response}
     */
  }, {
    key: "apitestGetConfigVariablePost",
    value: function apitestGetConfigVariablePost(Accept_Language, opts) {
      return this.apitestGetConfigVariablePostWithHttpInfo(Accept_Language, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-email-token
     * Test call that returns email_token for specified user(if exists)
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestGetEmailTokenPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetEmailTokenPost200Response} and HTTP response
     */
  }, {
    key: "apitestGetEmailTokenPostWithHttpInfo",
    value: function apitestGetEmailTokenPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestGetEmailTokenPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestGetEmailTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetEmailTokenPost200Response["default"];
      return this.apiClient.callApi('/apitest/get-email-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-email-token
     * Test call that returns email_token for specified user(if exists)
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ApitestGetEmailTokenPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetEmailTokenPost200Response}
     */
  }, {
    key: "apitestGetEmailTokenPost",
    value: function apitestGetEmailTokenPost(Accept_Language, params) {
      return this.apitestGetEmailTokenPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-last-report-ids
     * Return uuid and report_id for last generated report for authorized user. Uuid can be used for download-user-report API call.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetLastReportIdsPost200Response} and HTTP response
     */
  }, {
    key: "apitestGetLastReportIdsPostWithHttpInfo",
    value: function apitestGetLastReportIdsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ApitestGetLastReportIdsPost200Response["default"];
      return this.apiClient.callApi('/apitest/get-last-report-ids', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-last-report-ids
     * Return uuid and report_id for last generated report for authorized user. Uuid can be used for download-user-report API call.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetLastReportIdsPost200Response}
     */
  }, {
    key: "apitestGetLastReportIdsPost",
    value: function apitestGetLastReportIdsPost() {
      return this.apitestGetLastReportIdsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-notification-logs
     * Return all notifications which was sent to given users.
     * @param {Object} opts Optional parameters
     * @param {module:model/GetNotificationLogs} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetNotificationLogsPost200Response} and HTTP response
     */
  }, {
    key: "apitestGetNotificationLogsPostWithHttpInfo",
    value: function apitestGetNotificationLogsPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetNotificationLogsPost200Response["default"];
      return this.apiClient.callApi('/apitest/get-notification-logs', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-notification-logs
     * Return all notifications which was sent to given users.
     * @param {Object} opts Optional parameters
     * @param {module:model/GetNotificationLogs} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetNotificationLogsPost200Response}
     */
  }, {
    key: "apitestGetNotificationLogsPost",
    value: function apitestGetNotificationLogsPost(opts) {
      return this.apitestGetNotificationLogsPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-reset-password-token
     * Test API call to get password token for reset-password API call.
     * @param {module:model/GetAccountTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetResetPasswordTokenPost200Response} and HTTP response
     */
  }, {
    key: "apitestGetResetPasswordTokenPostWithHttpInfo",
    value: function apitestGetResetPasswordTokenPostWithHttpInfo(params) {
      var postBody = params;
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestGetResetPasswordTokenPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetResetPasswordTokenPost200Response["default"];
      return this.apiClient.callApi('/apitest/get-reset-password-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-reset-password-token
     * Test API call to get password token for reset-password API call.
     * @param {module:model/GetAccountTokenParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetResetPasswordTokenPost200Response}
     */
  }, {
    key: "apitestGetResetPasswordTokenPost",
    value: function apitestGetResetPasswordTokenPost(params) {
      return this.apitestGetResetPasswordTokenPostWithHttpInfo(params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-sample-users
     * Get all sample users(bots)
     * @param {Object} opts Optional parameters
     * @param {module:model/GetSampleUsers} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetSampleUsersPost200Response} and HTTP response
     */
  }, {
    key: "apitestGetSampleUsersPostWithHttpInfo",
    value: function apitestGetSampleUsersPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetSampleUsersPost200Response["default"];
      return this.apiClient.callApi('/apitest/get-sample-users', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-sample-users
     * Get all sample users(bots)
     * @param {Object} opts Optional parameters
     * @param {module:model/GetSampleUsers} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetSampleUsersPost200Response}
     */
  }, {
    key: "apitestGetSampleUsersPost",
    value: function apitestGetSampleUsersPost(opts) {
      return this.apitestGetSampleUsersPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-section-field
     * Test call that retrieves all connected records of the specified section field.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/GetSectionFieldParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiGetSectionFieldObject} and HTTP response
     */
  }, {
    key: "apitestGetSectionFieldPostWithHttpInfo",
    value: function apitestGetSectionFieldPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestGetSectionFieldPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestGetSectionFieldPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiGetSectionFieldObject["default"];
      return this.apiClient.callApi('/apitest/get-section-field', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-section-field
     * Test call that retrieves all connected records of the specified section field.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/GetSectionFieldParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiGetSectionFieldObject}
     */
  }, {
    key: "apitestGetSectionFieldPost",
    value: function apitestGetSectionFieldPost(Accept_Language, params) {
      return this.apitestGetSectionFieldPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-server-time
     * Return UTC time in provided format. Format can be 'null', 'timestamp' or other like 'Y-m-d'
     * @param {Object} opts Optional parameters
     * @param {module:model/GetServerTimeParams} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApitestGetServerTimePost200Response} and HTTP response
     */
  }, {
    key: "apitestGetServerTimePostWithHttpInfo",
    value: function apitestGetServerTimePostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApitestGetServerTimePost200Response["default"];
      return this.apiClient.callApi('/apitest/get-server-time', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-server-time
     * Return UTC time in provided format. Format can be 'null', 'timestamp' or other like 'Y-m-d'
     * @param {Object} opts Optional parameters
     * @param {module:model/GetServerTimeParams} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApitestGetServerTimePost200Response}
     */
  }, {
    key: "apitestGetServerTimePost",
    value: function apitestGetServerTimePost(opts) {
      return this.apitestGetServerTimePostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * invalid-token
     * Invalidate given token. It means that this token can't be refreshed by keep-alive API call or login with it instead of password.
     * @param {Object} opts Optional parameters
     * @param {module:model/InvalidToken} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestInvalidateTokenPostWithHttpInfo",
    value: function apitestInvalidateTokenPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/invalidate-token', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * invalid-token
     * Invalidate given token. It means that this token can't be refreshed by keep-alive API call or login with it instead of password.
     * @param {Object} opts Optional parameters
     * @param {module:model/InvalidToken} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestInvalidateTokenPost",
    value: function apitestInvalidateTokenPost(opts) {
      return this.apitestInvalidateTokenPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * prepare-institution-files
     * Test call that executes function for preparing export files for an institution.
     * @param {module:model/PrepareInstitutionFilesParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestPrepareInstitutionFilesPostWithHttpInfo",
    value: function apitestPrepareInstitutionFilesPostWithHttpInfo(params) {
      var postBody = params;
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestPrepareInstitutionFilesPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/prepare-institution-files', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * prepare-institution-files
     * Test call that executes function for preparing export files for an institution.
     * @param {module:model/PrepareInstitutionFilesParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestPrepareInstitutionFilesPost",
    value: function apitestPrepareInstitutionFilesPost(params) {
      return this.apitestPrepareInstitutionFilesPostWithHttpInfo(params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * process-notifications
     * Test call that triggers cron job for processing notifications.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestProcessNotificationsPostWithHttpInfo",
    value: function apitestProcessNotificationsPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/process-notifications', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * process-notifications
     * Test call that triggers cron job for processing notifications.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestProcessNotificationsPost",
    value: function apitestProcessNotificationsPost() {
      return this.apitestProcessNotificationsPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * remove-flood-block
     * Test call that removes all flood events for the IP of the requester.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestRemoveFloodBlockPostWithHttpInfo",
    value: function apitestRemoveFloodBlockPostWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/remove-flood-block', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * remove-flood-block
     * Test call that removes all flood events for the IP of the requester.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestRemoveFloodBlockPost",
    value: function apitestRemoveFloodBlockPost() {
      return this.apitestRemoveFloodBlockPostWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * set-config-variable
     * Change configuration variable value. It will remove variable from database if value set to `null`
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Object} opts Optional parameters
     * @param {module:model/ApitestSetConfigVariablePostRequest} [ApitestSetConfigVariablePostRequest] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response} and HTTP response
     */
  }, {
    key: "apitestSetConfigVariablePostWithHttpInfo",
    value: function apitestSetConfigVariablePostWithHttpInfo(Accept_Language, opts) {
      opts = opts || {};
      var postBody = opts['ApitestSetConfigVariablePostRequest'];
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestSetConfigVariablePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['aplication/json', 'application/json'];
      var returnType = _ProgramsUpdateProgramProgressPost200Response["default"];
      return this.apiClient.callApi('/apitest/set-config-variable', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * set-config-variable
     * Change configuration variable value. It will remove variable from database if value set to `null`
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Object} opts Optional parameters
     * @param {module:model/ApitestSetConfigVariablePostRequest} opts.ApitestSetConfigVariablePostRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ProgramsUpdateProgramProgressPost200Response}
     */
  }, {
    key: "apitestSetConfigVariablePost",
    value: function apitestSetConfigVariablePost(Accept_Language, opts) {
      return this.apitestSetConfigVariablePostWithHttpInfo(Accept_Language, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * update-user-info
     * Allows to update access and activation timestamp of a user
     * @param {Object} opts Optional parameters
     * @param {module:model/ApiUserInfoObject} [params] 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestUpdateUserInfoPostWithHttpInfo",
    value: function apitestUpdateUserInfoPostWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['params'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['TestSecret', 'token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/update-user-info', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * update-user-info
     * Allows to update access and activation timestamp of a user
     * @param {Object} opts Optional parameters
     * @param {module:model/ApiUserInfoObject} opts.params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestUpdateUserInfoPost",
    value: function apitestUpdateUserInfoPost(opts) {
      return this.apitestUpdateUserInfoPostWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * wait-report-completion
     * This API call keep connection while report generation in progress. To avoid situation when report generation was failed but status wasn't changed it has timeout 10 minutes from report `requestedAt` time.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/WaitReportCompletionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "apitestWaitReportCompletionPostWithHttpInfo",
    value: function apitestWaitReportCompletionPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling apitestWaitReportCompletionPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling apitestWaitReportCompletionPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/apitest/wait-report-completion', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * wait-report-completion
     * This API call keep connection while report generation in progress. To avoid situation when report generation was failed but status wasn't changed it has timeout 10 minutes from report `requestedAt` time.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/WaitReportCompletionParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "apitestWaitReportCompletionPost",
    value: function apitestWaitReportCompletionPost(Accept_Language, params) {
      return this.apitestWaitReportCompletionPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();